<template>
    <section id="dose-dependent-content">
        <div class="container">
            <div class="content">
                <span class="eyebrow-page omnes fw-semibold text-orange"
                    >Downloadable Resources</span
                >
                <h1 class="gtitle fw-semibold savings-title">
                    JORNAY PM resources for you and your patients
                </h1>
            </div>

            <div class="content pt-0 pt-md-4 pb-4 downloadable-cards-container">
                <DownloadableResourcesCard
                    v-for="(item, index) in resources"
                    :key="index"
                    :imageDesktopSrc="item.imageDesktopSrc"
                    :imageMobileSrc="item.imageMobileSrc"
                    :title="item.title"
                    :description="item.description"
                    :downloadLink="item.downloadLink"
                    :downloadTitle="item.downloadTitle"
                    :altName="item.altName"
                />
            </div>
        </div>
    </section>
</template>

<script>
import DownloadableResourcesCard from '@/components/downloadableResources/DownloadableResourcesCard.vue';
export default {
    components: {
        DownloadableResourcesCard,
    },
    data() {
        return {
            resources: [
                {
                    title: 'Pharmacy instructions',
                    description:
                        'Follow these tips to help patients with processing the JORNAY PM savings card',
                    imageDesktopSrc: 'resources/res1.png',
                    imageMobileSrc: 'resources/res1-m.png',
                    downloadLink: '/pharmacy-instructions.pdf',
                    downloadTitle: 'Download Pharmacy Instructions',
                    altName: 'Pharmacy Instructions brochure',
                },
                // {
                //     title: 'Learn how patients can save on JORNAY PM',
                //     description:
                //         'Help your patients find out if they’re eligible for savings',
                //     imageDesktopSrc: 'resources/res2.png',
                //     imageMobileSrc: 'resources/res2-m.png',
                //     downloadLink: '/savings-brochure.pdf',
                //     downloadTitle: 'Download Savings',
                //     altName: 'Savings brochure',
                // },
                {
                    title: 'Dosing and optimization guide',
                    description:
                        'Provides details on dosing, including initiation and titration',
                    imageDesktopSrc: 'resources/res3.png',
                    imageMobileSrc: 'resources/res3-m.png',
                    downloadLink: '/PP-JNY-US-0476 JORNAY PM Dosing Guide (Digital) Clickable.pdf',
                    downloadTitle: 'Download Dosing',
                    altName: 'Dosing and Information Guide',
                },
                {
                    title: 'Clinical overview brochure',
                    description:
                        '<span class="card-text-4">Provides an overview of the study design, primary and secondary endpoints, and dose optimization</span>',
                    imageDesktopSrc: 'resources/res4.png',
                    imageMobileSrc: 'resources/res4-m.png',
                    downloadLink: '/JORNAY PM Clinical Brochure.pdf',
                    downloadTitle: 'Download Clinical Overview',
                    altName: 'Clinical Overview Brochure',
                },
            ],
        };
    },
};
</script>
